var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.address
      ? _c(
          "div",
          {
            class: "woocommerce-" + _vm.formName + "-fields",
            attrs: { id: _vm.formName + "-form" }
          },
          [
            _vm.formName === "billing" && !_vm.hideTitle
              ? _c("h2", { staticClass: "checkout__subsection__heading" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$modeoL10n.billing_information) +
                      "\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.formName === "shipping"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "checkout-form-additional checkout-form-additional--shipping-address"
                  },
                  [
                    _c("label", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.useShippingAddress,
                            expression: "useShippingAddress"
                          }
                        ],
                        staticClass: "checkbox-input",
                        attrs: {
                          id: "ship-to-different-address-checkbox",
                          type: "checkbox",
                          name: "ship_to_different_address"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.useShippingAddress)
                            ? _vm._i(_vm.useShippingAddress, null) > -1
                            : _vm.useShippingAddress
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.useShippingAddress,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.useShippingAddress = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.useShippingAddress = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.useShippingAddress = $$c
                              }
                            },
                            _vm.addressChanged
                          ],
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkbox-label" }, [
                        _vm._v(_vm._s(_vm.$modeoL10n.separate_shipping_address))
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.formName === "billing" || _vm.useShippingAddress,
                    expression: "formName === 'billing' || useShippingAddress"
                  }
                ]
              },
              [
                _vm.formName === "shipping"
                  ? _c("h2", { staticClass: "checkout__subsection__heading" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$modeoL10n.shipping_address) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasErrors,
                        expression: "hasErrors"
                      }
                    ],
                    staticClass: "address-form__errors error-notification"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$modeoL10n.errors_in_form) +
                        " " +
                        _vm._s(_vm.$modeoL10n.errors_in_address_form) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    key: _vm.refresh,
                    class:
                      "woocommerce-" + _vm.formName + "-fields__field-wrapper"
                  },
                  _vm._l(_vm.formFields, function(field, key) {
                    return _c(
                      "div",
                      {
                        key: key,
                        staticClass: "form-row",
                        class: field.class.join(" "),
                        attrs: { id: key + "_field" }
                      },
                      [
                        _c(
                          "label",
                          {
                            class: {
                              "form-label-has-error": _vm.errors.has(key)
                            },
                            attrs: { for: key }
                          },
                          [
                            _vm._v(_vm._s(field.label) + "\n            "),
                            field.required
                              ? _c(
                                  "abbr",
                                  {
                                    staticClass: "required",
                                    attrs: { title: "vaaditaan" }
                                  },
                                  [_vm._v("*")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        field.type === "country"
                          ? [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$modeoL10n.finland))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  id: key,
                                  type: "hidden",
                                  name: key,
                                  value: "FI"
                                }
                              })
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        field.type != "country"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.address[_vm.getIndex(key)],
                                  expression: "address[getIndex(key)]"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.getValidations(field, key),
                                  expression: "getValidations(field, key)"
                                }
                              ],
                              staticClass: "input-text",
                              class: {
                                "form-field-has-error": _vm.errors.has(key)
                              },
                              attrs: {
                                id: key,
                                type: "text",
                                name: key,
                                placeholder: "",
                                autocomplete: field.autocomplete,
                                disabled: key === _vm.formName + "_country"
                              },
                              domProps: {
                                value: _vm.address[_vm.getIndex(key)]
                              },
                              on: {
                                change: function($event) {
                                  return _vm.fieldChanged(field)
                                },
                                blur: function($event) {
                                  return _vm.fieldFocusOut(key)
                                },
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.address,
                                    _vm.getIndex(key),
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has(key)
                          ? _c(
                              "span",
                              { staticClass: "form-field-error-message" },
                              [_vm._v(_vm._s(_vm.errors.first(key)))]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _vm.formName === "billing" && !_vm.userLoggedIn && !_vm.hideRegister
              ? _c(
                  "div",
                  {
                    staticClass:
                      "checkout-form-additional checkout-form-additional--register"
                  },
                  [
                    _c("label", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.register,
                            expression: "register"
                          }
                        ],
                        staticClass: "checkbox-input",
                        attrs: {
                          type: "checkbox",
                          name: "createaccount",
                          value: "1"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.register)
                            ? _vm._i(_vm.register, "1") > -1
                            : _vm.register
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                          },
                          change: function($event) {
                            var $$a = _vm.register,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "1",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.register = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.register = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.register = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkbox-label" }, [
                        _vm._v(_vm._s(_vm.$modeoL10n.create_account))
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.register
                      ? _c("div", [
                          _c(
                            "p",
                            {
                              staticClass: "form-row validate-required",
                              attrs: {
                                id: "account_password_field",
                                "data-priority": ""
                              }
                            },
                            [
                              _c(
                                "label",
                                {
                                  class: {
                                    "form-label-has-error": _vm.errors.has(
                                      "password"
                                    )
                                  },
                                  attrs: { for: "account_password" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$modeoL10n.select_password) + " "
                                  ),
                                  _c(
                                    "abbr",
                                    {
                                      staticClass: "required",
                                      attrs: { title: "vaaditaan" }
                                    },
                                    [_vm._v("*")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "input-text",
                                class: {
                                  "form-field-has-error": _vm.errors.has(
                                    "password"
                                  )
                                },
                                attrs: {
                                  id: "account_password",
                                  type: "password",
                                  name: "account_password",
                                  placeholder: _vm.$modeoL10n.password,
                                  value: ""
                                },
                                domProps: { value: _vm.password },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.errors.has("password")
                                ? _c(
                                    "span",
                                    { staticClass: "form-field-error-message" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("password"))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-348c3c13", { render: render, staticRenderFns: staticRenderFns })
  }
}